import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import { Container } from './styled'
import { TabelaMicrorganismos } from './tabela'
import FormularioMicrorganismo from './formulario'
import PageContainer from '../../../../Components/pageContainer'
import { useGetMicrorganismos } from '../../../../services/admMicrorganismos/GET'
import {
  usePostMicrorganismos,
  usePutMicrorganismos,
} from '../../../../services/admMicrorganismos/POST'
import { useDeleteMicrorganismos } from '../../../../services/admMicrorganismos/DELETE'
import { api } from '../../../../services/api'

const CadastroMicrorganismos = () => {
  //TABELA
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
   const [filtradoAtivo, setFiltradoAtivo] = useState<boolean>(false)
  const [total1, setTotal1] = useState(null)
  const [carregou, setCarregou] = useState(true)

  //FORMULARIO
  const [update, setUpdate] = useState<number>(null)
  const [openGaveta, setOpenGaveta] = useState<boolean>(false)
  const [bacteria_fungo, setBacteria_fungo] = useState<string>('')
  const [bacteria_fungo_id, setBacteria_fungo_id] = useState<number>(null)
  const [nome, setNome] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [data_tipo, setData_tipo] = useState([])

  //API
  const { carregando_mircrorganismos, data_mircrorganismos, refetch_data_mircrorganismos } =
    useGetMicrorganismos(pagination, page, buscarTabela)
  const { carregando_salvar_microrganismos, mutate_microrganismos } = usePostMicrorganismos()
  const { carregando_edit_microrganismos, mutate_edit_microrganismos } =
    usePutMicrorganismos(update)
  const { carregando_deletar_microrganismos, mutate_deletar_microrganismos } =
    useDeleteMicrorganismos()
  const tiposSistemaGeral = async () => {
    const response = await api.get(`/tipos-sistema?pagination=-1`)

    const filtro_biologico = response.data.itens.filter((item) => item?.cod_tipo_geral === 262)
    setData_tipo(filtro_biologico)
  }

  function abriGaveta() {
    setOpenGaveta(true)
  }

  function fecharGaveta() {
    setOpenGaveta(false)
    setUpdate(null)
    setNome('')
    setBacteria_fungo('')
    setBacteria_fungo_id(null)
    refetch_data_mircrorganismos()
  }

  function editar(cod) {
    setLoading(true)
    setUpdate(cod)
    const filtro = data_mircrorganismos?.itens?.filter((item) => item?.cod === cod)
    setNome(filtro[0]?.nome_cientifico)
    setBacteria_fungo(filtro[0]?.tipo_microrganismo_nome)
    setBacteria_fungo_id(filtro[0]?.tipo_microrganismo)
    setOpenGaveta(true)
    setTimeout(() => {
      setLoading(false)
    }, 600)
  }

  function cadastrarMicrorganimos() {
    if (update <= 0) {
      mutate_microrganismos({
        nome_cientifico: nome,
        tipo_microrganismo: bacteria_fungo_id,
        refetch_microrganismos: fecharGaveta,
      })
    } else {
      mutate_edit_microrganismos({
        nome_cientifico: nome,
        tipo_microrganismo: bacteria_fungo_id,
        refetch_microrganismos: fecharGaveta,
      })
    }
  }

  function deletarMicrorganismos(cod) {
    setFake_loading(true)
    mutate_deletar_microrganismos({
      cod_microrganismos: cod,
      refetch_deletar: refetch_data_mircrorganismos,
    })

    setTimeout(() => {
      setFake_loading(false)
    }, 600)
  }

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        setFiltradoAtivo(true)
        refetch_data_mircrorganismos()
      }, 700)
    }
   if (carregou === false) {
     if (buscarTabela === '' || buscarTabela.length <= 0) {
     setTimeout(() => {
        refetch_data_mircrorganismos()
        setFiltradoAtivo(false)
      }, 700)
    }
   }
  }, [buscarTabela])

  useEffect(() => {
    if (filtradoAtivo === false) {
      setTotal1(data_mircrorganismos?.total)
    }
  }, [data_mircrorganismos?.total])

  useEffect(() => {
    console.log('PAGINATION')
    refetch_data_mircrorganismos()
  }, [pagination])

  useEffect(() => {
    refetch_data_mircrorganismos()
  }, [page])

  useEffect(() => {
    refetch_data_mircrorganismos()
    tiposSistemaGeral()
    setTimeout(() => {
      setCarregou(false)
    }, 700);
  }, [])

  return (
    <PageContainer>
      <TitleH1>Microrganismos</TitleH1>
      <TabelaMicrorganismos
        listar_microrganismo={data_mircrorganismos?.itens}
        carregando_microrganismo={carregando_mircrorganismos}
        total={data_mircrorganismos?.total}
        excluir={deletarMicrorganismos}
        confirmar_exclusao={confirmar_exclusao}
        buscarTabela={buscarTabela}
        abrir={abriGaveta}
        setBuscarTabela={setBuscarTabela}
        editar={editar}
        setConfirmar_exclusao={setConfirmar_exclusao}
        id_item_atual={id_item_atual}
        setId_item_atual={setId_item_atual}
        nome_item_atual={nome_item_atual}
        setNome_item_atual={setNome_item_atual}
        fake_loading={fake_loading}
        setFake_loading={setFake_loading}
        setPagination={setPagination}
        page={page}
        setPage={setPage}
        filtroAtivado={filtradoAtivo}
        setFiltroAtivado={setFiltradoAtivo}
        totalRef={total1}
      />
      <FormularioMicrorganismo
        nome={nome}
        setNome={setNome}
        bacteria_fungo={bacteria_fungo}
        setBacteria_fungo={setBacteria_fungo}
        setBacteria_fungo_id={setBacteria_fungo_id}
        editar={update}
        openGaveta={openGaveta}
        fecharGaveta={fecharGaveta}
        cadastrar={cadastrarMicrorganimos}
        loadingSalvar={carregando_salvar_microrganismos ?? carregando_edit_microrganismos}
        loadingEditar={loading}
        data_tipo={data_tipo}
      />
    </PageContainer>
  )
}

export default CadastroMicrorganismos
